import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';

export type ExportDownloadErrorCode =
	| 'FILE_NOT_READY'
	| 'NOT_FOUND'
	| 'UNAUTHORIZED'
	| 'UNKNOWN_ERROR'
	| 'GENERIC_ERROR'
	| 'NO_DATA';
type ExportDownloadErrorType = { code: ExportDownloadErrorCode; message: TranslationKey };

export const EXPORT_DOWNLOAD_ERROR_MAP: Record<ExportDownloadErrorCode, ExportDownloadErrorType> = {
	FILE_NOT_READY: {
		code: 'FILE_NOT_READY',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.file_not_ready'),
	},
	NOT_FOUND: {
		code: 'NOT_FOUND',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.not_found'),
	},
	UNAUTHORIZED: {
		code: 'UNAUTHORIZED',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.unauthorized'),
	},
	UNKNOWN_ERROR: {
		code: 'UNKNOWN_ERROR',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.unkown_error'),
	},
	GENERIC_ERROR: {
		code: 'GENERIC_ERROR',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.generic_error'),
	},
	NO_DATA: {
		code: 'NO_DATA',
		message: translationKey('corgi.petition.starter_dashboard.export_download.response_options.no_data'),
	},
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const exportDownloadErrorCodes = Object.keys(EXPORT_DOWNLOAD_ERROR_MAP) as ReadonlyArray<
	keyof typeof EXPORT_DOWNLOAD_ERROR_MAP
>;
